export default "__VITE_PUBLIC_ASSET__439ad16f__"